import { Component, OnInit } from '@angular/core';
import { TransactionResult } from '../../../../core/services/interfaces/transaction-result';
import { IRoles } from '../Interfaces/IRoles';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { DatePipe } from '@angular/common';
import { IScreens } from '../Interfaces/IScreens';
import { Router } from '@angular/router';
import { RolesService } from '../services/roles-service';
import { RolesDetailsComponent } from './roles-details/roles-details.component';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { DisableRoleComponent } from './disable-role/disable-role.component';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
declare var $: any;

@Component({
	selector: 'app-roles',
	templateUrl: './roles.component.html',
	styleUrls: ['roles.component.scss'],
})
export class RolesComponent implements OnInit {
	listData: IRoles[] = [];
	loading = false;
	station: string = 'TABLE';
	columns: Array<any> = [
		'role',
		'strcreationdate',
		'employeecreatorname',
		'strlastupdated',
		'employeeupdatername',
		'changestatuscolumn',
		'editcolumn',
	];
	displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);

	public dataRole: IRoles = {
		pkrole: 0,
		role: '',
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 1,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 1,
		fkrecordstatus: 1,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
		recordstatusname: '',
		check: false,
		available: false,
		fksite: 0,
		editable: false,
	};

	constructor(
		private roleService: RolesService,
		private notificationService: NotificationService,
		public dialog: MatDialog,
		private datePipe: DatePipe,
		public router: Router,
		public translate: TranslateApplicationService,
		private cognitoService: CognitoService,
	) {}

	ngOnInit() {
		const component = this;
		$('.btnReload').click(function () {
			component.GetRolesComponent();
		});
		component.GetRolesComponent();
	}

	GetRolesComponent() {
		this.loading = true;
		this.roleService.EmployeeHasPermissionToScreen('Roles').subscribe(
		(result: TransactionResult<IScreens[]>) => {
			this.loading = false;
			if (result.success) {
				if (result.data == null || result.data.length == 0)
					this.router.navigateByUrl('/main/without-permission');
			}
			else{
				this.ErrorMessage('ROLES.Error_employee_has_permission');
				this.router.navigateByUrl('/main/without-permission');
			}
		},
		(error: any) => { 
			this.ErrorAlert(error); this.loading = false; 
		});
		this.GetRoles();
	}

	GetRoles() {
		this.loading = true;
		this.roleService.GetRolesBySite().subscribe(
		(result: TransactionResult<IRoles[]>) => {
			this.loading = false;
			if (result.success) {
				
				this.listData = result.data;
				this.listData.forEach((element) => {
					element.strcreationdate = this.datePipe.transform(
						element.creationdate,
						'yyyy-MM-dd HH:mm:ss',
					);
					element.strlastupdated = this.datePipe.transform(
						element.lastupdated,
						'yyyy-MM-dd HH:mm:ss',
					);
				});
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error: any) => { this.ErrorAlert(error); this.loading = false; },);
	}

	AddRole() {
		this.dataRole.editable = true;
		const dialogRef = this.dialog.open(RolesDetailsComponent, {
			data: this.dataRole,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.GetRoles();
			}
		});
	}

	EditRole(item: IRoles) {
		const dialogRef = this.dialog.open(RolesDetailsComponent, {
			data: item,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.GetRoles();
			}
		});
	}

	ViewRole(item: IRoles) {
		const dialogRef = this.dialog.open(RolesDetailsComponent, {
			data: item,
		});
		dialogRef.afterClosed().subscribe((result) => {});
	}

	ValidateUserRole(item: IRoles) {
		this.loading = true;
		this.roleService.GetRoleByUser().subscribe(
		(result: TransactionResult<IRoles>) => {
			this.loading = false;
			if (item.role == result['role']) {
				this.cognitoService.LogOut();
			}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	ChangeStatus(item: IRoles) {
		if (item.available) {
			const dialogRef = this.dialog.open(DisableRoleComponent, {
				data: item,
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result) {
					this.GetRoles();
					this.ValidateUserRole(item);
				}
			});
		} 
		else if (item.role) {
			this.roleService.ChangeRoleStatus(item).subscribe(
			(result: TransactionResult<Boolean>) => {
				this.loading = false;
				if (result.success) {
					this.Alert(
						'Success',
						this.translate.TranslateKey('COMPLETE'),
					);
					this.GetRoles();
					this.ValidateUserRole(item);
				} else {
					this.Alert(
						'Warning',
						this.translate.TranslateKey('WARNING.Failed_updated_status'),
					);
				}
			},
			(error: any) => { 
				this.ErrorAlert(error); this.loading = false; 
			});
		}
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: message,
			shown: true,
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
	}

	ErrorMessage(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}
}
